// src/pages/TiposFactura.js
import React, { useState } from "react";
import { Button, Container, Typography, Alert } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikTextField from "../components/FormikTextField";
import { useAuth } from "../context/AuthContext";
import { useSftfApi } from "../api/sftfClient";

export default function TiposFactura() {
  const { auth } = useAuth();
  const { postConsulta } = useSftfApi(auth);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Consulta por Tipo de Factura
      </Typography>
      <Formik
        initialValues={{ ClaveTipoFactura: "" }}
        validationSchema={Yup.object({
          ClaveTipoFactura: Yup.string().required("Requerido")
        })}
        onSubmit={async (values) => {
          try {
            const query = `claveTipoFactura=${values.ClaveTipoFactura}`;
            const res = await postConsulta(query);
            setResult(res);
            setError(null);
          } catch (err) {
            setError(err.message || "Error desconocido");
            setResult(null);
          }
        }}
      >
        <Form>
          <FormikTextField name="ClaveTipoFactura" label="Clave Tipo Factura" />
          <Button type="submit" variant="contained">Consultar</Button>
        </Form>
      </Formik>
      {result && <pre>{JSON.stringify(result, null, 2)}</pre>}
      {error && <Alert severity="error">{error}</Alert>}
    </Container>
  );
}
